var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFaqInfos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166 152",
    style: {
      enableBackground: "new 0 0 166 152"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFCB03;stroke-width:3;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "INFOS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,50.23c-6.42,0-11.64-5.22-11.64-11.64s5.22-11.64,11.64-11.64s11.65,5.22,11.65,11.64 C101.94,45,96.72,50.23,90.3,50.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.03,54.78c3.99,0.25,6.9,1.47,8.64,3.64c2.53,3.15,1.92,7.46,1.93,7.46l-10.7,42.84 c-0.07,0.36-0.67,3.65,1.38,5.85c0.75,0.8,2.06,1.68,4.26,1.68c0.39,0,0.81-0.03,1.26-0.09c1.07-0.14,2.18-0.32,3.26-0.5 c1.36-0.23,3.2-0.53,4.45-0.61c-1.77,2.88-7.56,8.94-18.83,8.94c-0.65,0-1.32-0.02-2.01-0.06c-3.99-0.25-6.9-1.47-8.64-3.64 c-2.53-3.15-1.92-7.46-1.93-7.46l10.7-42.84c0.08-0.37,0.67-3.66-1.37-5.85c-0.75-0.8-2.06-1.68-4.26-1.68 c-0.39,0-0.81,0.03-1.26,0.09c-1.07,0.14-2.18,0.33-3.26,0.51c-1.36,0.22-3.2,0.53-4.45,0.6c1.76-2.88,7.56-8.94,18.81-8.94 C83.66,54.71,84.34,54.73,85.03,54.78z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 83.5,
    cy: 75.5,
    r: 69.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqInfos);
export default __webpack_public_path__ + "static/media/faq-infos.6acfbd754bc7cc387d4b2bed9f389aef.svg";
export { ForwardRef as ReactComponent };